// extracted by mini-css-extract-plugin
export default {"floor":"Floor_floor__TxlmB","overFive":"Floor_overFive__IyEzQ","active":"Floor_active__prhtP"};